// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressEditModal-module__wrapper--NLKck","headline":"AddressEditModal-module__headline--JhY3A","inputBlock":"AddressEditModal-module__inputBlock--_tRLw"};